var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNuts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3802_1937)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8282 0V2.10938C21.9172 2.10938 19.5547 4.47187 19.5547 7.38281H17.4453C17.4453 6.01165 17.825 4.70384 18.5 3.60696C19.7867 1.45547 22.1281 0 24.8282 0Z",
    fill: "#663325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5547 7.38281H18.5V3.60696C19.7867 1.45547 22.1281 0 24.8282 0V2.10938C21.9172 2.10938 19.5547 4.47187 19.5547 7.38281Z",
    fill: "#3C1B13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1016 15.8203V19.2164C30.1016 26.1562 26.1993 32.9203 18.5 36C10.843 32.9414 6.89845 26.1985 6.89845 19.2164V15.8203H30.1016Z",
    fill: "#FF9D82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1016 15.8203V19.2164C30.1016 26.1562 26.1993 32.9203 18.5 36V15.8203H30.1016Z",
    fill: "#FF815E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7188 6.32812H14.2812C9.05 6.32812 4.78906 10.589 4.78906 15.8203V16.875H32.2109V15.8203C32.2109 10.589 27.9499 6.32812 22.7188 6.32812Z",
    fill: "#8C4A37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.211 15.8203V16.875H18.5V6.32812H22.7188C27.95 6.32812 32.211 10.589 32.211 15.8203Z",
    fill: "#663325"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3802_1937"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNuts);
export default __webpack_public_path__ + "static/media/nuts.2e4e11c5f8ddebc5d450c5ea2b52a012.svg";
export { ForwardRef as ReactComponent };